(() => {
  "use strict";

  const mainImage = document.querySelector("[data-product-image]");
  const thumbs = document.querySelector("[data-product-thumbs]");
  const lightbox = document.querySelector("[data-image-lightbox]");
  const lightboxImage = lightbox?.querySelector("img");
  const uploadDialog = document.querySelector("[data-upload-review-dialog]");
  const uploadReview = uploadDialog?.querySelector("img");
  const input = document.querySelector("[data-photo-input]");
  let reviewUrl = "";

  thumbs?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-gallery-image]");
    if (!button) return;
    mainImage.src = button.dataset.galleryImage;
    thumbs.querySelectorAll("button").forEach((item) => item.classList.toggle("active", item === button));
  });
  document.querySelector("[data-image-zoom]")?.addEventListener("click", () => {
    lightboxImage.src = mainImage.src;
    lightbox.showModal();
  });
  lightbox?.querySelector("[data-image-lightbox-close]")?.addEventListener("click", () => lightbox.close());
  lightbox?.addEventListener("click", (event) => { if (event.target === lightbox) lightbox.close(); });

  input?.addEventListener("change", () => {
    const file = input.files?.[0];
    if (!file || !uploadDialog) return;
    if (reviewUrl) URL.revokeObjectURL(reviewUrl);
    reviewUrl = URL.createObjectURL(file);
    uploadReview.src = reviewUrl;
    uploadDialog.showModal();
  });
  uploadDialog?.querySelectorAll("[data-upload-review-use]").forEach((button) => button.addEventListener("click", () => uploadDialog.close()));
  uploadDialog?.querySelector("[data-upload-review-change]")?.addEventListener("click", () => { uploadDialog.close(); input.click(); });
  uploadDialog?.addEventListener("close", () => { document.querySelector("[data-generate-button]")?.focus(); });

  document.querySelector("[data-sticky-customize]")?.addEventListener("click", () => document.querySelector(".customization-box")?.scrollIntoView({ behavior: "smooth", block: "center" }));
  const stickyBar = document.querySelector(".sticky-product-bar");
  const updateStickyBar = () => stickyBar?.classList.toggle("is-visible", window.scrollY > Math.min(620, window.innerHeight * .72));
  updateStickyBar();
  window.addEventListener("scroll", updateStickyBar, { passive: true });
  window.addEventListener("resize", updateStickyBar);
  document.querySelector("[data-buy-now]")?.addEventListener("click", () => {
    const form = document.querySelector("[data-cart-form]");
    const submit = document.querySelector("[data-cart-button]");
    if (form && submit && !submit.disabled) form.requestSubmit(submit);
  });
})();
